/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_TitleInputs */



/**
* | output |
* | --- |
* | "Archival results" |
*
* @param {Archival_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_title = /** @type {((inputs?: Archival_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résultats d'archive")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultados de archivo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Resultados de arquivo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risultati d'archivio")
	return /** @type {LocalizedString} */ ("Archival results")
});